import React, { useState } from 'react';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { encryptPayload } from '../utils/encryption';

export default function AboutBusiness() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [website, setWebsite] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [about, setAbout] = useState("");
 
    const submitData = async () => {
       if (!about.trim()) {
    toast.error("Please enter about your business");
    return;
  }
        setLoading(true)
        const token = sessionStorage.getItem('registrationToken');
        const entity_type = sessionStorage.getItem('company_type');
        const name = sessionStorage.getItem('selectedcompanyName');
        const turnover = sessionStorage.getItem('turnover');
        const selectedcompanyNumber = sessionStorage.getItem('selectedcompanyNumber');
        const selectedcompanyHouseNumber = sessionStorage.getItem('selectedcompanyHouseNumber');
        const selectedcompanyStreet = sessionStorage.getItem('selectedcompanyStreet');
        const selectedcompanyAddress = sessionStorage.getItem('selectedcompanyAddress');
        const selectedcompanyPostalCode = sessionStorage.getItem('selectedcompanyPostalCode');
        const selectedcompanyCountry = sessionStorage.getItem('selectedcompanyCountry');
        const selectedcompanyStatus = sessionStorage.getItem('selectedcompanyStatus');
        sessionStorage.setItem('businessEmail',email);
        sessionStorage.setItem('businessPhone',phone);
        var deviceId = sessionStorage.getItem('deviceid');
        var userid = sessionStorage.getItem('userid');
        const encryptedPayload = await encryptPayload({
            "is_registered": "1",
            "entity_type": entity_type,
            "name": name,
            "website": website,
            "email": email,
            "country_code": "",
            "phone": phone,
            "description": about,
            "turnover": turnover,
            "registration_no": selectedcompanyNumber,
            "house_no": selectedcompanyHouseNumber,
            "street": selectedcompanyStreet,
            "address_info": selectedcompanyAddress,
            "postal_code": selectedcompanyPostalCode,
            "city": null,
            "country_id": selectedcompanyCountry,
            "company_status": selectedcompanyStatus,
            "platform": 'web',
            "extraParamValidation": 'trustedfromweb'
        });

        const dropencryptedPayload = await encryptPayload({
                screen_name: "ABOUT_BUSINESS_7",
                meta: { website: website, email: email, phone: phone,about:about},
                device_id: deviceId,
                user_id: userid
              });
                    
        await axios.post(Constants.BASE_URL + "API-FX-175-BUSINESS-REGISTRATION-COMPANY-DETAILS",encryptedPayload,{headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + token
        }}).then(resp=>{
            
            
            resp.data
            axios.post(Constants.BASE_URL + "API-FX-159-DROPSCREEN", dropencryptedPayload, {
                headers: {
                  fx_key: Constants.SUBSCRIPTION_KEY
                }
              }).then(dropresponse => {
                dropresponse.data
                setLoading(false)
                navigate('/BusinessAddress');
              }).catch(dropError => {
                console.log(dropError);
                setLoading(false)
                toast.error(dropError.response.data.message)
              })


        }).catch(err=>{
            setLoading(false)
            toast.error(err.response.data.message);
        })
    }
    return (
        <div className="min-h-screen w-full bg-white flex flex-col">
          <div className="w-full border-b border-[#0B214E33] py-6 px-6">
            <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
          </div>
        
                    <ToastContainer />

            <div className='flex flex-1 items-center justify-center px-4'>

<div className="w-full max-w-[720px] mx-auto">
                <div className="flex items-center mb-4 pt-3 cursor-pointer" onClick={() => navigate("/BusinessDetails")}>
        <img src="./arrow-left.svg" alt="back" />
        <span className="text-lg font-bold">Tell Us About Your Business</span>
      </div>
                <div className="flex items-center mb-4 bg-custom-gray-light rounded-md w-full">
                    <input
                        type="url"
                        placeholder="Company website"
                        className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                    />
                </div>


                <div className="flex items-center mb-4 bg-custom-gray-light rounded-md w-full">
                    <input
                        type="email"
                        placeholder="Company email"
                        className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                <div className="flex items-center mb-4 bg-custom-gray-light rounded-md w-full">
                    <input
                        type="number"
                        placeholder="Company phone"
                        className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </div>

                <div className="flex items-center mb-6 bg-custom-gray-light rounded-md w-full">
  <textarea
    rows={3}
    placeholder="About business"
    className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-[#000000] placeholder:text-sm resize-none"
    value={about}
    onChange={(e) => setAbout(e.target.value)}
  />
</div>

                <PrimaryButton
                    onClick={submitData}
                    label={"Continue"}
                    loading={loading}
                />

             </div>
        </div>
        </div>
    );
}